module.exports = __webpack_public_path__ + "static/media/ic-assessment.bf378700.svg";